import React from "react";
import FileUpload, { FileUploadProps } from "./FileUpload";

export type CVFileValue = string | undefined;

interface FileUploadCVProps extends Omit<FileUploadProps, "accept" | "maxSize" | "buttonText"> {
  buttonText?: string;
  onFileRemove?: () => void;
  required?: boolean;
  status?: "idle" | "uploading" | "success" | "error";
  fileName?: string;
  errorMessage?: string;
  showSelectedFile?: boolean;
}

const FileUploadCV = React.forwardRef<HTMLDivElement, FileUploadCVProps>(
  (
    {
  buttonText = "Upload CV",
  onFileRemove,
  onFileSelect,
  required = true,
  status = "idle",
  fileName,
  errorMessage,
      showSelectedFile,
  ...props
    },
    ref
  ) => {
  // Only show file info if upload was successful
  const showFileInfo = status === "success" && fileName;

  return (
    <div ref={ref} className="space-y-2">
        {/* Show selected file (before upload) */}
        {showSelectedFile && fileName && (
          <div className="p-4 border border-border rounded-md">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <span className="text-sm font-medium">
                  Selected file: {fileName}
                </span>
              </div>
              <button
                type="button"
                onClick={onFileRemove}
                className="text-destructive hover:text-destructive/80"
                aria-label="Remove file"
              >
                ✕
              </button>
            </div>
          </div>
        )}

        {/* Show upload button only if no file is selected and not uploaded */}
        {!showSelectedFile && !showFileInfo && (
        <FileUpload
          accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            maxSize={5 * 1024 * 1024} // 5MB
          buttonText={buttonText}
            dragDropText={`Drag and drop your CV here, or click to select${required ? " (required)" : ""}`}
            onFileRemove={onFileRemove}
            onFileSelect={onFileSelect}
          required={required}
          status={status}
          {...props}
        />
      )}

      {/* Show file info only after successful upload */}
      {showFileInfo && (
        <div className="p-4 border border-border rounded-md">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <span className="text-sm font-medium">
                Selected file: {fileName}
              </span>
            </div>
            <button
              type="button"
                onClick={onFileRemove}
              className="text-destructive hover:text-destructive/80"
              aria-label="Remove file"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Show error message from props if provided */}
      {errorMessage && status === "error" && (
        <div className="text-sm font-medium text-destructive mt-2">
          {errorMessage}
        </div>
      )}
    </div>
  );
  }
);

FileUploadCV.displayName = "FileUploadCV";

export default FileUploadCV;
